import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-colorpicker',
  standalone: true,
  imports: [FormsModule ,CommonModule],
  templateUrl: './colorpicker.component.html',
  styleUrl: './colorpicker.component.css'
})
export class ColorpickerComponent {
  selectedColor = '#1A4971';
  updateColorPicker() {
    // Validate the hex color format
    if (/^#([0-9A-F]{3}){1,2}$/i.test(this.selectedColor)) {
      // Valid hex color, no further action needed as [(ngModel)] will sync
    } else {
      // Handle invalid input, if necessary
      console.error('Invalid hex color:', this.selectedColor);
    }
  }

}
